import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './custom-paginator.component.html',
  styleUrls: ['./custom-paginator.component.scss'],
})
export class CustomPaginatorComponent {
  totalLength: number;
  itemPerPage: number;
  currentPage: number;
  totalPages: number;
  itemPerPageSelectedValue: number;
  selectedPage: number;
  forwardCount: number;
  backwardCount: number;
  isSelectedPage:boolean=true;
  isCalculatedPageSize:boolean=true;
  showDoEmition: boolean = false;
  itemsPerPage:number;

  @Input('items-per-page') set _itemsPerPage(val: any) {
    this.itemsPerPage = val;
  }
  @Input('show-Emition') set _(val: any) {
    this.showDoEmition = val;
  }
  @Input('selected-page') set _selectedPage(val: any) {
    this.selectedPage = val;
    this.isSelectedPage=false;
  }
  @Input('page-size') set _pageSize(val: any) {
    this.itemPerPageSelectedValue = val;
    this.isCalculatedPageSize=false;
  }
  @Input('total-length') set _totalLength(val: number) {
    this.totalLength = val;
    this.numberOfItemsPerPageOption = this.itemPerPageItems.filter((x) => x <= this.totalLength ||
      ((this.totalLength > (this.itemPerPageItems[this.itemPerPageItems.indexOf(x) - 1] ?? 0)) && this.totalLength < x));
      if(this.isCalculatedPageSize){
        this.itemPerPageSelectedValue = this.numberOfItemsPerPageOption.length > 0 ? this.numberOfItemsPerPageOption[0] : 10;
      }
    if(this.isSelectedPage){
      this.selectedPage=1;
    }
    if(this.itemsPerPage){
      this.itemPerPageSelectedValue=this.itemsPerPage;
    }
    this.calculateItemPerPage(this.itemPerPageSelectedValue);
    this.calculateBackwarAndForwardCount();
    if (this.showDoEmition) {
      this.doEmition();
    }
  }
  itemPerPageItems = [10, 20, 50, 100];
  public numberOfItemsPerPageOption: Array<number>;
  pagesItem = [10, 20, 50, 100];
  @Output() emitData: EventEmitter<any>;
  constructor() {
    this.emitData = new EventEmitter<any>();
    this.numberOfItemsPerPageOption = Array.of<number>();
  }

  public changeItemPerPage(value: number): void {
    this.calculateItemPerPage(value);
    this.calculateBackwarAndForwardCount();
    this.doEmition();
  }

  private calculateItemPerPage(value: any): void {
    const trunc = Math.trunc(this.totalLength / value);
    const totalDivident = this.totalLength / value;
    this.totalPages = totalDivident > trunc ? trunc + 1 : trunc;
    this.selectedPage = this.selectedPage <= this.totalPages ? this.selectedPage : this.totalPages;
  }

  public changeSelectedPage(value: number): void {
    this.selectedPage = value;
    this.calculateBackwarAndForwardCount();
    this.doEmition();
  }

  public navigationButton(type: string): void {
    if (type === 'Forward') {
      if (this.selectedPage < this.totalPages) {
        this.selectedPage = this.selectedPage + 1;
      }
    } else {
      if (this.selectedPage > 1) {
        this.selectedPage = this.selectedPage - 1;
      }
    }
    this.calculateBackwarAndForwardCount();
    this.doEmition();
  }

  private calculateBackwarAndForwardCount(): void {
    this.backwardCount =
      this.selectedPage * this.itemPerPageSelectedValue -
      this.itemPerPageSelectedValue +
      1;
    this.forwardCount =
      this.selectedPage * this.itemPerPageSelectedValue > this.totalLength
        ? this.totalLength
        : this.selectedPage * this.itemPerPageSelectedValue;
  }

  private doEmition(): void {
    this.emitData.emit({
      x: this.backwardCount - 1,
      y: this.forwardCount,
      pageSize: this.itemPerPageSelectedValue,
      selectedPage: this.selectedPage,
    });
  }

  arrayOne(n: number): any[] {
    return Array(n);
  }
}
